// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadProgressIndicator_container__17jbz","loading":"UploadProgressIndicator_loading__1drom","percentage":"UploadProgressIndicator_percentage__1XKnH"};